export const qrCodeTheme = {
  bg: 'palette.white',
  borderRadius: '12px',
  code: 'palette.black',
};
